export default {
	expdigDiagnose: {
		deviceModel: '设备模型图',
		waveSpectrum: '波形频谱图',
		eigenvalue: '特征值',
		multiWave: '多波形',
		timeDomainTrend: '时域指标多趋势',
		multiSpectrum: '多频谱',
		envelopeDemod: '包络解调',
		orderAnalysis: '阶次分析',
		orderEnvelope: '阶次包络',
		waterfall: '瀑布图',
		cepstrum: '倒谱',
		crossSpectrumPhase: '交叉谱相位',
		multiSensorIndicator: '多测点指标',
		axisOrbit: '轴心轨迹',
		component: '部件',
		healthLifePredict: '健康度与寿命预测',
		singleValueBar: '单值棒图',
		bodePlot: '波特图',
		multiParameter: '多参数分析',
		runStatus: '运行状态图',
		indicatorDiagram: '示功图',
		pistonRodTrajectory: '活塞杆轨迹图',
		stressMonitor: '应力监测',
		impactDiag: '冲击诊断',
		vibrationMonitor: '振动监测',
		pistonRodSettlement: '活塞杆沉降/偏摆监测',
		historyCompare: '历史比较图',
		otherParameter: '其他参数',
		instantSpeedMonitor: '瞬时转速监测',
		torsionalVibration: '扭振监测',
		orderAnalysisICE: '阶次分析 (内燃机)',
		orderEnvelopeICE: '阶次包络 (内燃机)',
		dcsTrend: '工艺量趋势',
		// 快捷选项
		last1Day: '最近 1 天',
		last3Days: '最近 3 天',
		last7Days: '最近 7 天',
		last1Month: '最近 1 个月',
		last3Months: '最近 3 个月',
		// 工具菜单
		trend: '趋势图',
		wave: '波形图',
		spectrum: '频谱图',
		amplitudeSpeed: '幅值转速图',
		phaseSpeed: '相位转速图',
		orderWave: '阶次波形',
		orderSpectrum: '阶次谱',
		envSpectrum: '包络谱',
		multiParameterAnalysis: '多参数分析',
		phaseDiffSpectrum: '相位差谱',
		xAxisWave: 'X 轴测点波形图',
		yAxisWave: 'Y 轴测点波形图',
		dynamicPressureTrend: '动态压力趋势图',
		// 工具按钮
		mark: '标记',
		export: '导出',
		modelAnnotation: '算法模型标注',
		dualCursor: '双游标',
		sideFrequency: '边频',
		filter: '滤波',
		abnormalAnnotation: '异常标注',
		peakSpectrumTable: '峰值谱线表',
		frequencyBand: '频带',
		multipleFrequency: '倍频',
		rotationFrequency: '转速',
		characteristicFrequency: '特征频率',
		// 其他
		gridLayout: '格栅布局',
		averageAmplitude: '平均幅值',
		clearanceFactor: '裕度指标',
		crestFactor: '峰值指标',
		impulseFactor: '脉冲指标',
		kurtosisFactor: '峭度指标',
		maximum: '最大值',
		mean: '均值',
		minimum: '最小值',
		peak: '峰值',
		peakToPeak: '峰峰值',
		rms: '有效值',
		rootAmplitude: '方根幅值',
		shapeFactor: '波形指标',
		skewnessFactor: '歪度指标',
		wideband: '宽带',
		narrowband: '窄带',
		// trendRef 组件
		time: '时间',
		peakValue: '峰值',
		rmsValue: '有效值',
		// com-list 组件
		lowFrequency: '低频',
		highFrequency: '高频',
		longWaveform: '长波形',
		selectAxial: '请选择轴向',
		selectedPoints: '已选择 {count} 个测点',
		noSelect: '未选择',
		xAxisPoint: 'X 轴测点',
		yAxisPoint: 'Y 轴测点',
		startDate: '起始日期',
		endDate: '截止日期',
		separator: ' - ',
		selectIndicator: '选择指标',
		multiChart: '多图表',
		singleChart: '单图表',
		resetChart: '重置图表',
		basicInfo: '基本信息',
		deviceOverview: '设备概况',
		deviceNumber: '设备编号',
		deviceName: '设备名称',
		deviceType: '设备类型',
		productionArea: '生产区域',
		deviceStatus: '设备状态',
		health: '健康度',
		alarmLevel: '告警等级',
		runtime: '运行时长',
		alarmTotal: '告警总数',
		lifePrediction: '寿命预测',
		month: '月',
		hour: 'h',
		running: '运行',
		online: '在线',
		stop: '停机',
		offline: '离线',
		unknown: '未知',
		normal: '正常',
		general: '一般',
		medium: '中等',
		severe: '严重',
		exportWaveButton: '导出时间段波形'
	},
	treeCom: {
		searchPlaceholder: '请输入设备关键字',
		expandLevel: '展开{level}级',
		levelList: ['一', '二', '三', '四'],
		allDevices: '全部设备',
		online: '在线',
		stop: '停机',
		offline: '离线'
	},
	fluidsChart: {
		startDate: '起始日期',
		endDate: '截止日期',
		resetChart: '重置图表'
	},
	comList: {
		pistonRodSettlement: '活塞杆沉降偏摆测点',
		cylinderSelection: '气缸选择'
	},
	collChart: {
		rawWave: '原始波形',
		spectrum: '频谱',
		waveform: '波形',
		spectrumChart: '频谱',
		trend: '趋势',
		samplingFreq: '采样频率',
		rpm: '转速',
		generalAlarm: '一般告警',
		mediumAlarm: '中等告警',
		severeAlarm: '严重告警',
		alarm: '告警',
		exportDialogTitle: '导出时间段波形数据',
		timeRange: '时间范围',
		rangeSeparator: '至',
		startTime: '开始时间',
		endTime: '结束时间',
		collectType: '采集类型',
		highFrequencyOption: '高频(02)',
		lowFrequencyOption: '低频(01)',
		longWaveformOption: '长波形(04)',
		exportTips: '单次最多导出 3000 个采样时间点，超出请缩小时间范围分批导出；数据量较大时导出耗时较长，请耐心等待。',
		cancel: '取消',
		confirmExport: '确认导出',
		timeRangeInvalid: '时间范围无效',
		selectTimeRange: '请选择时间范围',
		exportFailed: '导出失败',
		exportSuccess: '导出成功',
		exportFailedRetry: '导出失败，请重试'
	},
	barChart: {
		noChartData: '暂无图表数据',
		status: '状态',
		normal: '正常',
		warning: '警告',
		danger: '危险'
	},
	bodeChart: {
		phase: '相位',
		amplitude: '幅值',
		rawData: '原始数据',
		tongpin: '通频',
		oneXFreq: '1倍频',
		twoXFreq: '2倍频',
		halfXFreq: '0.5倍频'
	},
	crossChart: {
		phaseDiffSpectrum: '相位差谱',
		amplitudeSpectrum: '幅值谱',
		samplingFreq: '采样频率',
		crossPoint: '交叉测点'
	},
	crewSidebar: {
		deviceName: '设备名称',
		sensorSelection: '测点选择',
		compareType: '比较类型',
		samePoint: '同一测点',
		diffPoint: '不同测点'
	},
	diagnoseSidebar: {
		deviceName: '设备名称',
		sensorSelection: '测点选择',
		pistonRodTrajectory: '活塞杆轨迹'
	},
	eigTags: {
		selectAll: '全选'
	},
	eigMultSingle: {
		featureValue: '特征值'
	},
	eigMultsSingle: {
		multiPointIndicator: '多测点指标'
	},
	fludisTrends: {
		indicatorDataTable: '指标数据统计表',
		time: '时间',
		export: '导出'
	},
	envCom: {
		envelopeSpectrum: '包络谱',
		spectrum: '频谱',
		samplingFreq: '采样频率',
		demodFreqBand: '解调频段'
	},
	filterCom: {
		filterConfig: '滤波配置',
		cancel: '取消',
		confirm: '确定',
		filter: '滤波器'
	},
	historyCompare: {
		historyTrend: '历史趋势图',
		historyWave: '历史波形图',
		mark: '标记',
		export: '导出',
		noData: '无数据',
		second: '秒',
		time: '时间'
	},
	healthLife: {
		deviceHealth: '设备健康度',
		remainingLife: '剩余寿命预测',
		healthTrendAnalysis: '设备健康度趋势分析',
		lifePredictionTrend: '剩余寿命预测趋势分析',
		last1Month: '最近1个月',
		last3Months: '最近3个月',
		last6Months: '最近6个月',
		last1Year: '最近1年',
		refresh: '刷新',
		healthDetailAnalysis: '健康度详细分析',
		impactFactorAnalysis: '影响因素分析',
		factor: '因素',
		weight: '权重',
		currentValue: '当前值',
		normalRange: '正常范围',
		impactDegree: '影响程度',
		maintenanceSuggestions: '维护建议',
		excellent: '优秀',
		good: '良好',
		normal: '一般',
		poor: '差',
		sufficient: '充足',
		needAttention: '需关注',
		needReplace: '需更换',
		rise: '上升',
		drop: '下降',
		stable: '稳定',
		healthDataUpdated: '健康度数据已更新',
		lifeDataUpdated: '寿命预测数据已更新',
		excellentLine: '优秀线',
		goodLine: '良好线',
		warningLine: '警告线',
		maxValue: '最大值',
		minValue: '最小值',
		remainingLifePrediction: '剩余寿命预测',
		predictedValue: '（预测值）',
		month: '月'
	},
	multChart: {
		rawWave: '原始波形',
		spectrum: '频谱',
		cepstrum: '倒谱',
		crossPhase: '交叉相位',
		waveform: '波形',
		samplingFreq: '采样频率'
	},
	indicatorDiagram: {
		dynamicPressureTrend: '动态压力趋势图',
		waveformChart: '波形图',
		time: '时间',
		noData: '无数据',
		exhaustShadow: '排气阴影',
		intakeShadow: '进气阴影',
		exhaustShadowArea: '排气阴影面积',
		intakeShadowArea: '进气阴影面积'
	},
	indicatorSidebar: {
		deviceName: '设备名称',
		compareType: '比较类型',
		sameSidePoint: '同一侧点',
		diffPoint: '不同测点',
		sensorSelection: '测点选择',
		diagramSelection: '图谱选择'
	},
	multParameter: {
		generalAlarm: '一般告警',
		mediumAlarm: '中等告警',
		severeAlarm: '严重告警',
		alarm: '告警',
		pistonRodSettlement: '活塞杆沉降 (um)',
		dynamicPressure: '动态压力 (kPa)',
		vibrationAcceleration: '振动加速度 (m/s2)',
		multiParameterAnalysis: '多参数分析 (角度/数值)',
		angle: '角度 (°)',
		orderWave: '阶次波形',
		orderSpectrum: '阶次谱',
		samplingFreq: '采样频率',
		rpm: '转速',
		turns: '转数(n)'
	},
	multTrends: {
		indicatorDataTable: '指标数据统计表',
		time: '时间',
		export: '导出',
		timeDomainIndicatorMultiTrend: '时域指标多趋势'
	},
	orderAnalysis: {
		trendChart: '趋势图',
		orderWave: '阶次波形',
		orderSpectrum: '阶次谱',
		mark: '标记',
		export: '导出',
		time: '时间',
		turns: '转数(n)',
		waveform: '波形',
		spectrum: '频谱',
		trend: '趋势',
		generalAlarm: '一般告警',
		mediumAlarm: '中等告警',
		severeAlarm: '严重告警',
		alarm: '告警',
		samplingFreq: '采样频率',
		rpm: '转速'
	},
	orderEnvelope: {
		trendChart: '趋势图',
		orderEnvelopeWave: '阶次包络波形',
		orderEnvelopeSpectrum: '阶次包络谱',
		mark: '标记',
		export: '导出',
		time: '时间',
		turns: '转数(n)',
		waveform: '波形',
		spectrum: '频谱',
		trend: '趋势',
		generalAlarm: '一般告警',
		mediumAlarm: '中等告警',
		severeAlarm: '严重告警',
		alarm: '告警',
		samplingFreq: '采样频率',
		rpm: '转速'
	},
	otherParameters: {
		otherParameterTrend: '其他参数趋势图',
		unknownPoint: '未知测点',
		trendChart: '趋势图'
	}
}
